export default "__VITE_ASSET__BKWhztFO__"